// Realtime socket for server push (mutation_changed and the rest of the WS traffic).
// The notification inbox stays dev-only; this flag only opens the socket.
// Off on stage and prod until the owner flips both files together — stage mirrors prod.
export const realtimeSocketEnabled = import.meta.env.VITE_ENABLE_REALTIME_SOCKET === 'true';

// Keep URL authentication on stage and prod until both enable the new WS contract.
export const wsFirstMessageAuthEnabled = import.meta.env.VITE_ENABLE_WS_FIRST_MESSAGE_AUTH === 'true';
